import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { Chip } from '@app/core';
import { ParticipationStatus, StudyType } from '@app/api';
import { getColorForParticipationStatus } from 'lib/participationUtils';
import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';

const useStyles = createUseStyles<string, {}, Theme>((theme: Theme) => ({
  container: {
    ...theme.fonts.label,
    color: theme.colors.white,
    marginBottom: theme.marginBase * 2,
  },
  chips: {
    marginTop: theme.marginBase,
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    justifyContent: 'flex-start',
    gap: theme.marginBase,
  },
}));

export const QuotaBoxHelp = ({ studyType }: { studyType: StudyType }) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  const { t } = useTranslation();

  const statusesAndColor = useMemo(() => {
    const common = [
      {
        status: ParticipationStatus.PARTICIPATED,
        color: getColorForParticipationStatus(ParticipationStatus.PARTICIPATED),
      },
      {
        status: ParticipationStatus.PAYMENT_REQUESTED,
        color: getColorForParticipationStatus(
          ParticipationStatus.PAYMENT_REQUESTED,
        ),
      },
    ];

    if (studyType === StudyType.MODERATED) {
      return [
        {
          status: ParticipationStatus.BOOKED,
          color: getColorForParticipationStatus(ParticipationStatus.BOOKED),
        },
        ...common,
      ];
    } else if (studyType === StudyType.UNMODERATED) {
      return [
        {
          status: ParticipationStatus.IN_PROGRESS,
          color: getColorForParticipationStatus(
            ParticipationStatus.IN_PROGRESS,
          ),
        },
        ...common,
      ];
    }

    return common;
  }, [studyType]);

  return (
    <div className={classes.container}>
      <div>
        <span>{t('sessions.details.boxes.quota.tooltips.help')}</span>
      </div>
      <div className={classes.chips}>
        {statusesAndColor.map((status) => (
          <Chip color={status.color} className={classes.chip}>
            {t(`sessions.details.boxes.quota.tooltips.${status.status}`, {
              context: studyType.toLowerCase(),
            })}
          </Chip>
        ))}
      </div>
    </div>
  );
};
